<template lang="pug">
Page(title="Member", :items="items")
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "Marketing", url: "/member/marketing" },
        { title: "Search", url: "/member/search" },
        { title: "Dashboard", url: "/member/dashboard" },
        { title: "Actions", url: "/member/actions" },
        { title: "Monthly Report", url: "/member/monthly" },
        { title: "Programs", url: "/member/programs" },
      ],
    };
  },
};
</script>
